module.exports = __webpack_public_path__ + "static/media/feature_flag_description_en.46137b2c.png";